export function isInternalUser(userId: string): boolean {
  return /@microsoft\.com$/i.test(userId)
}
